module.exports = __webpack_public_path__ + "img/slide5-768.940ae8b9.png";